var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import { forwardRef, } from 'react';
import { getFlexClasses } from '../../utils/getFlexClasses';
import { getFlexItemClasses } from '../../utils/getFlexItemClasses';
/**
 * Renders a flex container
 */
export const Flex = forwardRef((props, ref) => {
    const { className, children, tag: Tag = 'div', alignItems, justifyContent, wrap, column, grow, shrink, alignSelf } = props, otherProps = __rest(props, ["className", "children", "tag", "alignItems", "justifyContent", "wrap", "column", "grow", "shrink", "alignSelf"]);
    return (_jsx(Tag, Object.assign({}, otherProps, { ref: ref, className: clsx(getFlexClasses(props), getFlexItemClasses(props), className) }, { children: children }), void 0));
});
//# sourceMappingURL=Flex.js.map